import {
  DISABLE_JOB_SELECTION,
  SET_DELIVERIES,
  SET_JOB_SELECTION,
  SET_LIST_FOCUS,
  DELIVERY_META_FORM,
  SET_FILTERED_ORDERS
} from '../types';
import { indexBy, isBoolean, isNumber, isObject } from 'underscore';
import { Delivery, TLDelivery } from '../../config/types/Routes';

export function adaptDeliveryToMeta(delivery: TLDelivery) {
  return DELIVERY_META_FORM.reduce((acc: { [key: string]: Delivery }, val: string) => {
    return {
      ...acc,
      [val]: ((isNumber(delivery[val]) || isBoolean(delivery[val]))
        ? delivery[val]
        : (delivery.delivery_address[val] || null))
    };
  }, {});
}

/**
 *
 * @param arr {Array} - the list that will be converted to a set
 * @param alt {String} - alternative identifier for edge cases like normalizing deliveries that some have a "multi" instead of "id"
 * this allows any array to be normalized
 * @returns {Object} - a set of the array
 */
export function normalize<T>(arr: T[], alt = 'id'): { [key: string]: T } {
  if (!Array.isArray(arr) && isObject(arr)) {
    return arr;
  }
  if (!Array.isArray(arr)) return;
  return indexBy(arr, (alt || 'id'));
}

export function filter_content(obj: Delivery, value: string) {
  const val = `${obj.contactcompany || ''} ${obj.customernr || ''}
   ${obj.postalcode || ''} ${obj.city || ''} ${obj.street || ''} ${obj.custom_id || ''}`;
  return val.toLowerCase().indexOf(value.toLowerCase()) !== -1;
}

export const setJobSelection = (selection: number[]) => ({
  type: SET_JOB_SELECTION,
  data: selection
});

export function disableSelection(selected: number[]) {
  return {
    type: DISABLE_JOB_SELECTION,
    data: selected
  };
}

export function setJobs(data: any) {
  return {
    type: SET_DELIVERIES,
    data
  };
}

export const focusListItem = (id: number) => ({
  type: SET_LIST_FOCUS,
  data: id
});

export const setFilteredOrders = (values: number[]) => ({
  type: SET_FILTERED_ORDERS,
  data: values
});
